import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { OrganizationDto } from '../../dtos/organization.dto';

@Injectable()
export class OrganizationsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(): Observable<readonly OrganizationDto[]> {
    return this.http.get<readonly OrganizationDto[]>(`${this.apiUrl}${API_ENDPOINTS.organizations.list}`);
  }
}
